import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { clone as t } from "../../core/lang.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as i } from "../../core/accessorSupport/decorators/subclass.js";
import r from "./SearchSource.js";
import { getResults as l, getSuggestions as a } from "./support/layerSearchUtils.js";

var _o;

var n = _o = /*#__PURE__*/function (_r) {
  _inherits(o, _r);

  var _super = _createSuper(o);

  function o(e) {
    var _this;

    _classCallCheck(this, o);

    _this = _super.call(this, e), _this.displayField = null, _this.exactMatch = null, _this.orderByFields = null, _this.searchFields = null, _this.searchTemplate = null, _this.suggestionTemplate = null, _this.getResults = function (e, t) {
      return l(_objectSpread({
        source: _assertThisInitialized(_this)
      }, e), t);
    }, _this.getSuggestions = function (e, t) {
      return a(_objectSpread({
        source: _assertThisInitialized(_this)
      }, e), t);
    };
    return _this;
  }

  _createClass(o, [{
    key: "layer",
    set: function set(e) {
      this._set("layer", e), e && e.load().catch(function () {});
    }
  }, {
    key: "name",
    get: function get() {
      return this._getLayerTitle() || "";
    },
    set: function set(e) {
      void 0 !== e ? this._override("name", e) : this._clearOverride("name");
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _o({
        autoNavigate: this.autoNavigate,
        filter: this.filter,
        maxResults: this.maxResults,
        maxSuggestions: this.maxSuggestions,
        minSuggestCharacters: this.minSuggestCharacters,
        outFields: this.outFields ? t(this.outFields) : null,
        placeholder: this.placeholder,
        popupEnabled: this.popupEnabled,
        prefix: this.prefix,
        resultGraphicEnabled: this.resultGraphicEnabled,
        resultSymbol: this.resultSymbol ? this.resultSymbol.clone() : null,
        suggestionsEnabled: this.suggestionsEnabled,
        suffix: this.suffix,
        withinViewEnabled: this.withinViewEnabled,
        displayField: this.displayField,
        exactMatch: this.exactMatch,
        layer: this.layer,
        searchFields: this.searchFields ? t(this.searchFields) : null,
        suggestionTemplate: this.suggestionTemplate,
        zoomScale: this.zoomScale
      });
    }
  }, {
    key: "_getFirstStringField",
    value: function _getFirstStringField() {
      var e, t;
      return null != (e = null == (t = this.layer.fieldsIndex.fields.find(function (e) {
        return "string" === e.type;
      })) ? void 0 : t.name) ? e : "";
    }
  }, {
    key: "_getDisplayField",
    value: function _getDisplayField() {
      return this.displayField || this.layer.displayField || this._getFirstStringField();
    }
  }, {
    key: "_getSearchFieldsString",
    value: function _getSearchFieldsString() {
      var e = this.layer,
          t = this.searchFields;
      if (!e.loaded) return "";
      return ": ".concat((t || [this._getDisplayField()]).map(function (t) {
        var s = e.getField(t);
        return s && s.alias || t;
      }).join(", "));
    }
  }, {
    key: "_getLayerTitle",
    value: function _getLayerTitle() {
      var e = this.layer;
      if (!e) return;
      var t = e.title;
      return t ? "".concat(t).concat(this._getSearchFieldsString()) : void 0;
    }
  }]);

  return o;
}(r);

e([s({
  json: {
    read: {
      source: "field.name"
    },
    write: {
      target: "field.name"
    }
  }
})], n.prototype, "displayField", void 0), e([s({
  json: {
    read: {
      source: "field.exactMatch"
    },
    write: {
      target: "field.exactMatch"
    }
  }
})], n.prototype, "exactMatch", void 0), e([s({
  value: null
})], n.prototype, "layer", null), e([s()], n.prototype, "name", null), e([s({
  type: [String],
  json: {
    write: !0
  }
})], n.prototype, "orderByFields", void 0), e([s()], n.prototype, "searchFields", void 0), e([s()], n.prototype, "searchTemplate", void 0), e([s()], n.prototype, "suggestionTemplate", void 0), n = _o = e([i("esri.widgets.Search.LayerSearchSource")], n);
var h = n;
export { h as default };